import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import QocTracker from '@eams-dev/js-qoc-tracker';

import NavBar from '_components/NavBar';
import NavLinks from '_components/NavBar/NavLinks';
import { URL_LOGIN, URL_SECURE_USER_GLOSSARY } from '_constants/urls';
import { actions } from '_redux';

import './styles.scss';

const componentBaseClass = 'qoc-main-layout-container';

function MainLayout(props = {}) {
  console.log('-- MainLayout props: ', props);
  const [showHamburgerMenu, setHamburgerMenu] = useState(false);
  const [isLogoutModalOpen, setLogoutModal] = useState(false);
  const { authenticated, children, location, logout } = props;

  const isLoginPathname = location.pathname === URL_LOGIN;
  console.log('-- MainLayout authenticated: ', authenticated);
  console.log('-- MainLayout isLoginPathname: ', isLoginPathname);
  console.log('-- MainLayout location.pathname: ', location.pathname);
  console.log('-- MainLayout URL_LOGIN: ', URL_LOGIN);

  const onClickHamburger = () => {
    if (showHamburgerMenu) {
      console.log('hamburger');
      QocTracker.trackEvent({
        eventName: `user-dashboard-hamburger-click`,
        eventPayload: {
          clientData: {
            screen: 'user-dashboard'
          }
        }
      });
      setHamburgerMenu(false);
    } else {
      setHamburgerMenu(true);
    }
  };

  const onLogoutFalse = () => {
    setLogoutModal(false);
  };

  const onLogoutCheck = () => {
    setLogoutModal(true);
  };

  const getSpecialGlossaryClassName = () => {
    if (location.pathname === URL_SECURE_USER_GLOSSARY) {
      return `${componentBaseClass}__content--glossary`;
    }

    return `${componentBaseClass}__content`;
  };

  return (
    <div className={componentBaseClass}>
      <div className="row no-gutters">
        <div className="col-xs-12 col-sm">
          <NavBar
            authenticated={authenticated}
            onClickHamburger={onClickHamburger}
            showHamburgerMenu={showHamburgerMenu}
            isLogoutModalOpen={isLogoutModalOpen}
            isLoginPathname={isLoginPathname}
            logout={logout}
            onLogoutCheck={onLogoutCheck}
            onLogoutFalse={onLogoutFalse}
          />
          {showHamburgerMenu ? (
            <div className={`${componentBaseClass}__menu`}>
              <NavLinks
                authenticated={authenticated}
                isLoginPathname={isLoginPathname}
                onLogoutCheck={onLogoutCheck}
                onClickHamburger={onClickHamburger}
              />
            </div>
          ) : (
            <div className={getSpecialGlossaryClassName()}>{children}</div>
          )}
        </div>
      </div>
    </div>
  );
}

MainLayout.propTypes = {
  authenticated: PropTypes.bool,
  children: PropTypes.node,
  location: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired
};

MainLayout.defaultProps = {
  authenticated: false,
  children: null
};

function mapStateToProps(state) {
  const authenticated = !!get(state, 'profile.profileVO.profile.profileUUID');

  return {
    authenticated
  };
}

function mapDispatchToProps(dispatch) {
  return {
    logout: props => dispatch(actions.authentication.logout(props))
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MainLayout)
);
